// src/hooks/useArSpaceNavigation.ts
import { useEffect, useCallback } from 'react';
import { usePathname, useSearchParams, useRouter } from 'next/navigation';

export const AR_LIST_KEY = 'arspace:lastListUrl';

export function useArSpaceNavigation() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();

  /**
   * 1. 紀錄功能：監聽路由並存入 SessionStorage
   * (放在 layout.tsx 呼叫)
   */
  useEffect(() => {
    const pathParts = pathname.split('/').filter(Boolean);
    const isDetailPage = pathParts[0] === 'ar-space' && pathParts.length >= 2;

    if (!isDetailPage) {
      const sp = searchParams.toString();
      // 只有在有參數時才加問號，避免產生 "/store/123?" 這種網址
      const fullUrl = pathname + (sp ? `?${sp}` : '');
      sessionStorage.setItem(AR_LIST_KEY, fullUrl);
    }
  }, [pathname, searchParams]);

  /**
   * 2. 跳轉功能：智慧關閉 Modal / 詳情頁
   * (在關閉按鈕點擊時呼叫)
   */
  const closeArSpace = useCallback(() => {
    if (typeof window === 'undefined') return;

    const lastListUrl = sessionStorage.getItem(AR_LIST_KEY);
    const isDirectEntry = window.history.length <= 1;

    // A. 直接貼網址進入 -> 回主列表
    if (isDirectEntry) {
      router.replace('/ar-space?order_by=new', { scroll: false });
      return;
    }

    // B. 有紀錄來源 -> 原路折返
    if (lastListUrl) {
      router.replace(lastListUrl, { scroll: false });
      return;
    }

    // C. 最後保險
    if (window.history.length > 1) {
      router.back();
    } else {
      router.replace('/ar-space?order_by=new', { scroll: false });
    }
  }, [router]);

  return { closeArSpace };
}
